import React from 'react';
import './AnimatedLayout.css';

interface AnimatedLayoutProps {
  children: React.ReactNode;
}

const AnimatedLayout: React.FC<AnimatedLayoutProps> = ({ children }) => (
  <div className="AnimatedLayout AnimatedLayout__Container">
    <main>{children}</main>
  </div>
);

export default AnimatedLayout;
